<template>
  <div class="container">
    <!-- 进度条 -->
    <div class="progressBar">
       <WProgressBar width="80%" />
    </div>
    <!-- 标题 -->
    <div class="choose-title">当前是什么状态</div>
    <div class="reminder">选择状态，推荐最适合的简历模板～（可多选）</div>
    <!-- 内容 -->
    <div class="content">
      <div v-for="(item, index) in jobStatusList" :key="index" class="item-layout" @click="onItemClick(item)">
        <div class="child-layout">
          <img :src="item.url" alt="" class="item-img">
          <span>{{ item.value }}</span>
        </div>
        <span class="iconfont iconxuanzhong check" v-if="selectedStatusList.includes(item.key)"></span>
      </div>
    </div>
    <!-- 底部按钮 -->
    <div class="bottom-layout">
      <div class="circle-btn" @click="onPrevious">
        <img src="https://files.wondercv.com/intention/ic_left_arrow.png" class="ic-btn" alt="">
      </div>
      <div class="circle-btn" :class="{active: selectedStatusList.length > 0}" @click="onNext">
        <img :src="selectedStatusList.length > 0 ? 'https://files.wondercv.com/intention/ic_white_right_arrow.png' : 'https://files.wondercv.com/intention/ic_left_arrow.png'" 
          class="ic-btn" :class="{right: selectedStatusList.length === 0}" alt="">
      </div>
    </div>
  </div>
</template>

<script>
  import WProgressBar from "@/components/global/w-progress-bar";
  import { mapState, mapActions, mapMutations } from "vuex";
  import { envMixin } from "@/assets/js/mixin/global";
  import { userMixin } from "@/assets/js/mixin/user";
  import { componentsMixin } from "@/assets/js/mixin/components";
  import intention from "@/api/api-list/intention";

  export default {
    name: "user-current-state",
    mixins: [ envMixin, componentsMixin, userMixin ],
    data() {
      return {
        isActiveNext: false, // 是否激活下一步按钮，true激活
        jobStatusList: [], // 原始全部数据
        selectedStatusList: [], // 已勾选的数据
      }
    },
    computed: {
      ...mapState('user', ['userData'])
    },
    async created() {
      let { identity } = this.$route.query;
      this.loadData(identity);
    },
    components: {
      WProgressBar,
    },
    methods: {
      ...mapMutations('user', ['cacheNewUserInfo']),
      // 上一步
      onPrevious() {
        this.cacheNewUserInfo(this.$route.query);
        this.$router.back();
      },
      // 下一步
      onNext() {
        if (this.selectedStatusList.length === 0) return;
        // 找工作、找全职、跳槽、转行、其他 其中的任意一项, 跳转至 求职意向意向
        let isJumpExpectWorkPage = false;
        for (let i=0; i<this.selectedStatusList.length; i++) {
          let targetItem = this.jobStatusList.find((item, index) => item.key === this.selectedStatusList[i]);
          if (targetItem['required']) {
            isJumpExpectWorkPage = true;
            break;
          }
        }
        if (isJumpExpectWorkPage) {
          this.$router.push('/account/expect-work');
        } else {
          this.$router.push("/cvs");
        }
      },
      async loadData(identity) { // 加载数据
        let selectedStatusResp = await intention.fetchSelectedJobStatus(this.cvAccountToken);
        if (selectedStatusResp.code === 1000) {
          this.selectedStatusList = selectedStatusResp.data.job_status || [];
        }
        console.log("已选择状态=>", selectedStatusResp);
        let resp = await intention.fetchJobStatusTemplate({status: identity});
        if (resp.code === 1000) {
          this.jobStatusList = resp.data;
        }
      },
      onItemClick(item) {
        console.log(item);
        let arr = this.selectedStatusList.slice();
        if (arr.includes(item.key)) {
          arr = arr.filter((child, index) => child != item.key);
        } else {
          arr.push(item.key);
        }
        this.selectedStatusList = arr;
        intention.updateUserJobStatus(this.cvAccountToken, {"job_status": this.selectedStatusList})
          .then(resp => {
            console.log('resp=>', resp);
          })
          .catch(err => {

          })
      }
    }
  };
</script>

<style lang="scss" scoped>
  .container {
    display: flex;
    flex-direction: column;
    height: 100vh;
    background: #ffffff;
    .progressBar {
      width: 100%;
      margin-top: 16px;
      padding: 0 24px;
    }
    .choose-title {
      padding: 43px 0 8px 24px;
      font-size: 24px;
      color: #404040;
      font-weight: 600;
    }
    .reminder {
      padding: 0 0 0 24px;
      color: #9C9C9C;
      font-size: 14px;
      font-weight: 400;
      margin-bottom: 43px;
    }
    .content {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      flex-wrap: wrap;
      padding: 0px 24px;
      .item-layout {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: calc(50% - 6px);
        height: 66px;
        margin: 0 0 11px 0px;
        padding: 0px 16px;
        background: #ffffff;
        box-shadow: 0px 2px 18px 0px rgba(5, 32, 82, 0.08);
        border-radius: 8px;
        font-weight: 500;
        color: #404040;
        font-size: 16px;
        .child-layout {
          display: flex;
          align-items: center;
          .item-img {
            width: 32px;
            height: 32px;
            margin: 0px 10px 0px 0px;
          }
        }
        .check {
          color: #FF6644;
          font-size: 16px;
        }
      }
    }
    .bottom-layout {
      position: absolute;
      bottom: 0;
      width: calc(100% - 48px) ;
      display: flex;
      // flex: 1;
      align-items: flex-end;
      justify-content: space-between;
      margin: 24px;
      .circle-btn {
        display: flex;
        width: 64px;
        height: 64px;
        background: #F9F9F9;
        border: 1px solid #F4F4F4;
        border-radius: 32px;
        justify-content: center;
        align-items: center;
        .ic-btn {
          width: 12px;
          height: 20px;
          &.right{
            transform: rotate(180deg);
          }
        }
        &.active {
          background: linear-gradient(180deg, #FF9F79 0%, #FF6644 100%);
          box-shadow: 0px 6px 24px -8px #FF6644;
          border: none;
        }
      }
    }
  }
</style>

